export interface ClientLink {
  label: string;
  href: string;
}

export interface ClientEntry {
  id: string;
  title: string;
  paragraphs: string[];
  link?: ClientLink;
}

export const CLIENTS: ClientEntry[] = [
  {
    id: "bluemarvel",
    title: "BlueMarvel Inc.",
    paragraphs: [
      "As Strategic Accounts Director (contract), I collaborated with the team to build our go-to-market motions in the US market, including effective prospecting methods, product & company presentations, needs discovery templates, business case & proposals, and tools to manage the entire sales cycle. Along with the sales team I helped close our first US deals and tee'd up a significant pipeline for the team to run with and execute against. At BlueMarvel, I leveraged AI to speed up and partially automate multiple aspects of the sales cycle from account research to tailored discoveries and presentations, resulting in a significant acceleration in qualified deals.",
    ],
  },
  {
    id: "xq-message",
    title: "XQ Message Inc.",
    paragraphs: [
      "XQ is a data security company that works for high encryption and security use cases including the US DOW and critical infrastructure providers. The technology encrypts data at the edge, as it is generated, and micro-segments the data while generating a unique key for each data packet or object. As the Sales Leader for XQ, I built and executed the commercial go-to-market strategy to support successful expansion into security for operational technology of critical infrastructure such as oil & gas and utilities.",
    ],
    link: { label: "xqmsg.co", href: "https://xqmsg.co/" },
  },
  {
    id: "vantedge-logistics",
    title: "Vantedge Logistics",
    paragraphs: [
      "Software solutions for oil & gas logistics, in particular automation of loading/unloading fuels at truck & rail terminals, optimizing processes at the terminals, and securely sharing data from transaction records. Vantedge worked with me to build a scalable sales organization, develop sales process & sales materials, train and upskill the sales team, and to achieve incredible sales growth. During my time there Vantedge grew sales by over 150% to over $5M.",
    ],
    link: { label: "www.vantedge.com", href: "http://www.vantedge.com/" },
  },
  {
    id: "power-dev",
    title: "Power Dev",
    paragraphs: [
      "Power Dev provides software & analytics to support the financial modeling of renewable energy project development across North America. I worked with them in a fractional VP Sales capacity to develop a sales process, sales materials, reliable forecasting & operations and to deliver on sales growth targets.",
    ],
    link: { label: "www.power.dev", href: "http://www.power.dev/" },
  },
  {
    id: "field-safe-solutions",
    title: "Field Safe Solutions",
    paragraphs: [
      "Field Safe solutions is an all-in-one solution to keep your field team and remote workers safe. Lone worker management and journey (trip) management ensures proactive safety measures are balanced by an ability to respond quickly in event of an emergency. Forms & documents management allows clients to save costs on related admin work - when workers are in the app anyway, they may as well get rid of multiple other paper processes. I work with Field Safe as an advisor and consultant to product development & sales execution.",
    ],
    link: {
      label: "www.fieldsafesolutions.com",
      href: "http://www.fieldsafesolutions.com/",
    },
  },
];

export interface AppFeature {
  id: string;
  title: string;
  body: string;
}

export const APP_FEATURES: AppFeature[] = [
  {
    id: "context",
    title: "Context is captured",
    body: "Every contact remembers how you met — when, where, and what you talked about — and it's all searchable.",
  },
  {
    id: "sync",
    title: "Always up to date",
    body: "Two-way sync with the contacts you already have. Changes come in, yours go out, and you review anything that clashes — nothing changes without your OK.",
  },
  {
    id: "card",
    title: "One card, your choice",
    body: "A digital business card with a QR code you can hand over in seconds. Basic, Work, or Personal — you choose what each person sees.",
  },
  {
    id: "intros",
    title: "Warm intros, less awkward",
    body: "Introduce two people you know in a couple of taps, or run a group intro session where everyone at an event swaps details with a single QR code.",
  },
  {
    id: "ask",
    title: "Ask PeopleiKnow",
    body: "A natural-language assistant that helps you find people and remember context, just by asking.",
  },
];

export interface Investment {
  name: string;
  description: string;
  href: string;
}

export const INVESTMENTS: Investment[] = [
  {
    name: "Zayzoon",
    description: "On-demand pay and financial wellness for deskless workers.",
    href: "http://www.zayzoon.com/",
  },
  {
    name: "Headversity",
    description:
      "Mental health training for workplaces and sport organizations.",
    href: "http://www.headversity.com/",
  },
  {
    name: "XQ Message",
    description: "Zero-trust data security and encryption platform.",
    href: "https://xqmsg.co/",
  },
  {
    name: "Visur",
    description:
      "Operational visibility software for industrial construction.",
    href: "http://www.visur.one/",
  },
  {
    name: "FieldSafe",
    description: "Lone-worker and field-safety management software.",
    href: "https://www.fieldsafesolutions.com/",
  },
  {
    name: "Pure Life Carbon",
    description:
      "Charged Carbon — the first carbon-based, stand-alone growing media for controlled-environment agriculture.",
    href: "https://purelifecarbon.com/",
  },
];

export const EVENTBRITE_URL =
  "https://www.eventbrite.ca/e/stampede-parade-techfast-2026-tickets-1984671541005?aff=oddtdtcreator";
